var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh - 48px)","position":"relative"},attrs:{"fluid":""}},[_c('TopMenu',{attrs:{"title":_vm.top_menu.title,"buttons":_vm.getButtons}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }